import React from "react";
import { Box, Container, Grid, Typography, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";
import patternBgImg from "../../../assets/images/pattern-bg-img.png";

const TicketSection = ({
    title,
    description,
    image,
    buttonText = "Contact Now",
}) => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                position: "relative",
                background: "#2b5c9e",
                py: 8,
                overflow: "hidden",
            }}
        >
            {/* PATTERN BACKGROUND */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `url(${patternBgImg})`,
                    backgroundRepeat: "repeat",
                    opacity: 0.08,
                }}
            />

            <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
                <Grid container spacing={6} alignItems="center">

                    {/* LEFT CONTENT */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography
                            sx={{
                                fontSize: { xs: "28px", md: "32px" },
                                fontWeight: 700,
                                color: "#fff",
                                mb: 2,
                            }}
                        >
                            {title}
                        </Typography>

                        {Array.isArray(description) ? (
                            description.map((para, index) => (
                                <Typography
                                    key={index}
                                    sx={{
                                        color: "rgba(255,255,255,0.85)",
                                        fontSize: "13px",
                                        lineHeight: 1.6,
                                        mb: 2,
                                        fontWeight: 500
                                    }}
                                >
                                    {para}
                                </Typography>
                            ))
                        ) : (
                            <Typography
                                sx={{
                                    color: "rgba(255,255,255,0.85)",
                                    fontSize: "14px",
                                    lineHeight: 1.9,
                                }}
                            >
                                {description}
                            </Typography>
                        )}

                        {/* BUTTON */}
                        <Box
                            sx={{
                                display: "inline-flex",
                                borderRadius: "10px",
                                border: "4px solid rgba(255,255,255,0.3)",
                            }}
                        >
                            <Box
                                onClick={() => navigate("/contact-us")}
                                sx={{
                                    display: "flex",
                                    overflow: "hidden",
                                    borderRadius: "6px",
                                }}
                            >
                                {/* MAIN BUTTON */}
                                <Button
                                    sx={{
                                        background: "#f5b400",
                                        color: "#fff",
                                        px: 3,
                                        py: 1,
                                        fontWeight: 700,
                                        textTransform: "none",
                                        borderRadius: "0",
                                        "&:hover": {
                                            background: "#e0a200",
                                        },
                                    }}
                                >
                                    Contact Now
                                </Button>

                                {/* ICON PART */}
                                <Box
                                    sx={{
                                        background: "#e0a200",
                                        px: 2,
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <ArrowForwardIcon sx={{ color: "#fff" }} />
                                </Box>
                            </Box>
                        </Box>
                    </Grid>

                    {/* RIGHT IMAGE */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box
                            sx={{
                                borderRadius: "16px",
                                border: "6px solid rgba(255,255,255,0.2)",
                                overflow: "hidden",
                            }}
                        >
                            <Box
                                component="img"
                                src={image}
                                alt="ticket"
                                sx={{
                                    width: "100%",
                                    display: "block",
                                }}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default TicketSection;